import React, { createContext, useContext, useCallback } from 'react';
import { loadWordsMapForSurah } from '../utils/staticQuranData';

const ArabicTextCacheContext = createContext();

export const useArabicTextCache = () => {
  const context = useContext(ArabicTextCacheContext);
  if (!context) {
    throw new Error('useArabicTextCache must be used within an ArabicTextCacheProvider');
  }
  return context;
};

/**
 * Thin compatibility layer. Real WBW data lives in staticQuranData's surah Map
 * (loadSurahChunk / loadWordsMapForSurah). The old per-ayah string cache was
 * write-only and caused N competing /words loads — removed.
 */
export const ArabicTextCacheProvider = ({ children }) => {
  const getCachedText = useCallback(() => undefined, []);
  const setCachedText = useCallback(() => {}, []);
  const isLoading = useCallback(() => false, []);
  const setLoading = useCallback(() => {}, []);

  /** Warm one surah WBW file (ignores ayahNumbers — whole chunk is one fetch). */
  const preloadAyahs = useCallback(async (surahId) => {
    if (surahId == null || surahId === '') return;
    try {
      await loadWordsMapForSurah(Number(surahId));
    } catch (error) {
      console.error(`Error warming WBW for surah ${surahId}:`, error);
    }
  }, []);

  const clearSurahCache = useCallback(() => {}, []);
  const clearCache = useCallback(() => {}, []);

  const value = {
    getCachedText,
    setCachedText,
    isLoading,
    setLoading,
    preloadAyahs,
    clearSurahCache,
    clearCache,
    cacheSize: 0,
  };

  return (
    <ArabicTextCacheContext.Provider value={value}>
      {children}
    </ArabicTextCacheContext.Provider>
  );
};
